export default {
  card: {
    title: 'Pagar com cartão',
    inputs: {
      number: {
        title: 'Número do cartão',
        placeholder: 'Introduza o número do cartão',
      },
      cvc: {
        title: 'CVC',
        placeholder: 'CVC',
      },
      expiry: {
        title: 'MM/AA',
        placeholder: 'MM/AA',
      },
    },
  },
  'driver-tips': {
    title: 'Obrigado por<br><span>apoiar os estafetas!</span>',
    description: '100% da sua gorjeta vai diretamente para',
    remember: 'Lembre-se: deixar gorjeta é totalmente opcional!',
    'confirmation-modal': {
      title: 'Confirme, por favor:',
      description: 'Tem a certeza de que quer enviar uma gorjeta de',
      error: 'O valor da gorjeta tem de estar entre $2 e $40.',
      actions: {
        confirm: 'Confirmar',
        cancel: 'Cancelar',
      },
    },
  },
  'tips-amount': {
    other: 'Outro',
  },
  'tips-component': {
    thanks: 'Obrigado! A sua gorjeta foi recebida e vai certamente alegrar o dia do estafeta.',
    more: 'Enviar mais gorjetas',
  },
  'tips-old': {
    title: 'Obrigado por<br><span>apoiar os estafetas!</span>',
    description: '100% da sua gorjeta vai diretamente para',
    btn: 'Pagar com cartão',
  },
}
